import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet-async'

import { Typography } from '@telavita-core/react-design-kit'

import { handleProfileCode } from '../../utils'
import { scrollToElement } from 'utils/scrollHandlers'

// STYLE
import './ProfessionalInfo.sass'

// STORE
import { setInfo } from 'redux/modules/socialLinks/actions'

// COMPONENTS
import { ProfessionalData, SocialLinks } from 'components'
import { ReactComponent as Clock} from 'static/svg/icon-clock.svg'
import { ReactComponent as EmptyPhoto} from 'static/svg/empty-photo.svg'

import Stars from 'static/svg/ratingStars.svg'
import { TVTVPSIQ } from 'settings/_profileSettings'

const DEFAULT_SCHEDULE_DURATION = 50

const ProfessionalInfo = ({
  description,
  image,
  name,
  documentNumber,
  product,
  type,
  rating,
  refReviewsEl,
}) => {
  const dispatch = useDispatch()
  // STORE
  const auth = useSelector((state) => state.auth)
  // LOCAL
  const plan = auth.planSelected

  const localUrl = window.location.href
  // const localUrl = 'http://dev.telavita.com.br/app/psicologia-online/maria-joaquina' // -> FOR TESTING PURPOSE
  const title = 'Telavita - ' + name
  const shortDescription = description?.slice(0, 160) || ''

  const scheduleDuration = product?.product.product_general.duration ?? DEFAULT_SCHEDULE_DURATION
  const hasPrice = product?.appointments[0]?.price

  // SET PROFESSIONAL PHOTO BY URL AS BACKGROUND
  function setPhoto () {
    return {
      'background': `url(${image})`,
      'backgroundSize': 'cover',
      'backgroundPosition': 'center center'
    }
  }

  // ADD '...' AT THE END OF STRINGS OVER LENGTH
  function removeChars (str) {
    const initial = str.indexOf('.')
    return str.slice(0, initial)
  }

  function updateSocialLinksStore () {
    dispatch(setInfo('title', title))
    dispatch(setInfo('baseUrl', localUrl))
  }

  useEffect(() => {
    // UPDATE STORE
    updateSocialLinksStore()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <meta property="og:title" content={title} />
        <meta property="og:url" content={localUrl} />
        <meta property="og:image" content={image} />
        <meta property="og:image:url" content={image} />
        <meta property="og:image:secure_url" content={image} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="256"/>
        <meta property="og:image:height" content="256"/>
        <meta property="og:description" content={title} />
        <meta name="description" content={shortDescription} />
        <meta name="robots" content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large" />
        <link rel="canonical" href={localUrl} />
        <title>{title}</title>
      </Helmet>

      <div className="ProfessionalInfo">
        <section className="ProfessionalInfo__professional">
          <div className='ProfessionalInfo__containerPhoto'>
            {
              image?.length === 0
                ? <EmptyPhoto className="ProfessionalInfo__containerPhoto__photo ProfessionalInfo__containerPhoto__photo--empty" />
                : <div className="ProfessionalInfo__containerPhoto__photo" style={setPhoto()} />
            }
          </div> 
          <div className="ProfessionalInfo__info">
            {rating > 0 && (
              <div className='ProfessionalInfo__rating'>
                <span onClick={() => scrollToElement(refReviewsEl)}>
                  <img
                    src={Stars}
                    alt='five golden stars'
                    style={{
                      paddingBottom: '3px',
                    }}
                  />
                  <Typography
                    variant='content2'
                  >
                    {`(${rating} ${rating === 1 ? 'avaliação' : 'avaliações'})`}
                  </Typography>
                </span>
              </div>
            )}
            <div className="ProfessionalInfo__personal">
              <p className="ProfessionalInfo__text ProfessionalInfo__text--main">{name}</p>
              <p className="ProfessionalInfo__text">{handleProfileCode(type)}{documentNumber}</p>
            </div>
            <div className="ProfessionalInfo__jobInfo">
              {/* PRICE, TIME AND SOCIAL LINKS */}
              <div className="ProfessionalInfo__group">
                { plan === null || plan?.partner_plan_is_particular && hasPrice ? <ProfessionalData label="No particular" spaced>{product?.appointments[0].currency} {removeChars(product?.appointments[0]?.price ?? '')}</ProfessionalData> : null }
                
                {type !== TVTVPSIQ && (
                  <ProfessionalData label="Duração da consulta"><Clock className="ProfessionalInfo__icon ProfessionalInfo__icon--atLabel" /> {scheduleDuration} min</ProfessionalData>
                )}
              </div>
              <SocialLinks forDesktop />
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export {
  ProfessionalInfo
}
